/**
 * @module root/web
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
// tslint:disable
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

export class AppCustomPreloader implements PreloadingStrategy {
  preload(route: Route, load: Function): Observable<any> {
    const loadRoute = (delay) => (delay ? timer(5000).pipe(mergeMap((_) => load())) : load());
    return route.data && route.data.preload ? loadRoute(route.data.delay) : of(null);
  }
}
